import { ContainerWithLogo } from '@side/pantry';
import type { ReactNode, RefObject } from 'react';

interface Props {
  children: ReactNode;
  ref?: RefObject<HTMLDivElement | null>;
}

export function FormContainer({ children, ref }: Props) {
  return (
    <ContainerWithLogo
      ref={ref}
      mobileBreakpoint="md"
      sx={{
        backgroundColor: 'background.default',
        flex: '1 1 auto',
        overflowY: 'auto',
      }}
    >
      {children}
    </ContainerWithLogo>
  );
}
